module.exports = __webpack_public_path__ + "static/media/13.ea4bc5a2.JPG";